import type { ErrorInfo, JSX } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { ErrorContainer, RetryButton, StyledResult } from './ErrorBoundary.styled';

function ErrorFallback(): JSX.Element {
  const handleReload = () => window.location.reload();

  return (
    <ErrorContainer>
      <StyledResult
        status="error"
        title="Oops! Algo deu errado"
        subTitle="Desculpe, ocorreu um erro inesperado."
        extra={[
          <RetryButton type="primary" key="reload" onClick={handleReload}>
            Tentar novamente
          </RetryButton>,
        ]}
      />
    </ErrorContainer>
  );
}

function handleError(error: unknown, info: ErrorInfo): void {
  if (error instanceof Error) {
    console.error('Error caught by ErrorBoundary:', error.message, error.stack);
  } else {
    console.error('Unknown error caught by ErrorBoundary:', error);
  }

  console.error('Component stack:', info.componentStack);
}

type IErrorBoundaryProps = {
  children: React.ReactNode;
};

export default function ErrorBoundaryComponent({ children }: IErrorBoundaryProps): JSX.Element {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
      {children}
    </ReactErrorBoundary>
  );
}
